import React from "react";

export default function Pagination({

    page,
    onPageChange

}) {

    if (!page || page.totalPages <= 1) {
        return null;
    }

    const {

        number,
        totalPages,
        first,
        last,
        totalElements,
        numberOfElements

    } = page;

    const pages = [];

    const start = Math.max(0, number - 2);
    const end = Math.min(totalPages - 1, number + 2);

    for (let i = start; i <= end; i++) {
        pages.push(i);
    }

    return (

        <div className="mt-4">

            <div className="d-flex justify-content-between align-items-center flex-wrap">

                <div className="text-muted">

                    Affichage de

                    <strong className="mx-1">

                        {numberOfElements}

                    </strong>

                    élément(s)

                    sur

                    <strong className="mx-1">

                        {totalElements}

                    </strong>

                </div>

                <nav>

                    <ul className="pagination mb-0">

                        <li
                            className={`page-item ${first ? "disabled" : ""}`}
                        >

                            <button
                                className="page-link"
                                onClick={() => onPageChange(0)}
                                disabled={first}
                            >

                                <i className="bi bi-chevron-double-left"></i>

                            </button>

                        </li>

                        <li
                            className={`page-item ${first ? "disabled" : ""}`}
                        >

                            <button
                                className="page-link"
                                onClick={() => onPageChange(number - 1)}
                                disabled={first}
                            >

                                <i className="bi bi-chevron-left"></i>

                            </button>

                        </li>

                        {

                            pages.map((index) => (

                                <li

                                    key={index}

                                    className={`page-item ${index === number ? "active" : ""}`}

                                >

                                    <button

                                        className="page-link"

                                        onClick={() => onPageChange(index)}

                                    >

                                        {index + 1}

                                    </button>

                                </li>

                            ))

                        }

                        <li
                            className={`page-item ${last ? "disabled" : ""}`}
                        >

                            <button
                                className="page-link"
                                onClick={() => onPageChange(number + 1)}
                                disabled={last}
                            >

                                <i className="bi bi-chevron-right"></i>

                            </button>

                        </li>

                        <li
                            className={`page-item ${last ? "disabled" : ""}`}
                        >

                            <button
                                className="page-link"
                                onClick={() => onPageChange(totalPages - 1)}
                                disabled={last}
                            >

                                <i className="bi bi-chevron-double-right"></i>

                            </button>

                        </li>

                    </ul>

                </nav>

            </div>

        </div>

    );

}